export default "__VITE_ASSET__GelnwW_e__"